import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Saldo_ordencompra.css';

const SaldoOrdenCompra = () => {
  const [saldoActual, setSaldoActual] = useState(0);
  const [loadingSaldo, setLoadingSaldo] = useState(false);
  const [planSeleccionado, setPlanSeleccionado] = useState('');
  const [publicacionSeleccionada, setPublicacionSeleccionada] = useState('');
  const [diasAdquiridos, setDiasAdquiridos] = useState('');
  const [planes, setPlanes] = useState({ premium: [], destacado: [] });
  const [publicaciones, setPublicaciones] = useState([]);
  const [loadingActivar, setLoadingActivar] = useState(false);
  const [mensajeActivar, setMensajeActivar] = useState('');
  const [errorActivar, setErrorActivar] = useState('');
  const navigate = useNavigate();

  const SALDO_DEV_URL = process.env.REACT_APP_SALDO_DEV_URL;

const featuresMap = {
    ASP: [
      '7 días de publicación',
      'Sin pausas disponibles',
      'Apareces en el inicio de la página (mejor valorización = mejor posición)',
      '[PREMIUM] Tu aviso e historias aparecen en los perfiles de OTRAS publicadoras',
      'Creación de historias y uso de agenda',
      'Vencimiento: 7 días'
    ],
    AMP: [
      '30 días de publicación',
      '[PAUSA] Hasta 120 horas (5 días) — puedes reactivar cuando quieras desde el gestor de avisos. Al agotar las horas, tu publicación se reactiva automáticamente',
      'Apareces en el inicio de la página (mejor valorización = mejor posición)',
      '[PREMIUM] Tu aviso e historias aparecen en los perfiles de OTRAS publicadoras',
      'Creación de historias y uso de agenda',
      'Vencimiento sin pausas: 30 días',
      'Vencimiento usando todas las pausas: 35 días'
    ],
    ADP: [
      '60 días de publicación',
      '[PAUSA] Hasta 240 horas (10 días) — puedes reactivar cuando quieras desde el gestor de avisos. Al agotar las horas, tu publicación se reactiva automáticamente',
      'Apareces en el inicio de la página (mejor valorización = mejor posición)',
      '[PREMIUM] Tu aviso e historias aparecen en los perfiles de OTRAS publicadoras',
      'Creación de historias y uso de agenda',
      'Vencimiento sin pausas: 60 días',
      'Vencimiento usando todas las pausas: 70 días'
    ],
    ASD: [
      '7 días de publicación',
      'Sin pausas disponibles',
      'Apareces en el inicio de la página (mejor valorización = mejor posición)',
      'Tus historias son visibles en el banner del inicio de la página',
      'Creación de historias y uso de agenda',
      'Vencimiento: 7 días'
    ],
    AMD: [
      '30 días de publicación',
      'Sin pausas disponibles',
      'Apareces en el inicio de la página (mejor valorización = mejor posición)',
      'Tus historias son visibles en el banner del inicio de la página',
      'Creación de historias y uso de agenda',
      'Vencimiento: 30 días'
    ],
    ADD: [
      '60 días de publicación',
      'Sin pausas disponibles',
      'Apareces en el inicio de la página (mejor valorización = mejor posición)',
      'Tus historias son visibles en el banner del inicio de la página',
      'Creación de historias y uso de agenda',
      'Vencimiento: 60 días'
    ]
  };

const cargarPublicaciones = async () => {
    try {
      const response = await fetch(`${SALDO_DEV_URL}/get_publicaciones_aprobadas.php`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      if (data.success) {
        setPublicaciones(data.data);
      }
    } catch (err) {
      console.error('Error cargando publicaciones:', err);
    }
  };

  // Helpers para mostrar "nombre - Estado" con color y orden: Pendiente, Vencido, Activo
  const ESTADO_ORDEN = { pendiente: 0, vencido: 1, activo: 2 };
  const ESTADO_LABEL = { pendiente: 'Pendiente', vencido: 'Vencido', activo: 'Activo' };
  const ESTADO_COLOR = { pendiente: '#FF8C00', vencido: '#CC0000', activo: '#008000' };

  const obtenerEstadoPublicacion = (estado_plan) => {
    if (!estado_plan) return 'pendiente';
    if (estado_plan.toUpperCase() === 'VENCIDO') return 'vencido';
    return 'activo'; // ACTIVO o PAUSADO
  };

  const publicacionesOrdenadas = [...publicaciones].sort((a, b) => {
    const estadoA = obtenerEstadoPublicacion(a.estado_plan);
    const estadoB = obtenerEstadoPublicacion(b.estado_plan);
    return ESTADO_ORDEN[estadoA] - ESTADO_ORDEN[estadoB];
  });

  useEffect(() => {
    cargarPlanes();
    cargarSaldo();
    cargarPublicaciones();
  }, []);

  const cargarPlanes = async () => {
    try {
      const response = await fetch(`${SALDO_DEV_URL}/get_planes.php`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      if (data.success) {
        setPlanes({ premium: data.premium, destacado: data.destacado });
      }
    } catch (err) {
      console.error('Error cargando planes:', err);
    }
  };

const cargarSaldo = async () => {
    try {
      const response = await fetch(`${SALDO_DEV_URL}/get_consultasaldo.php`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      if (data.success) {
        setSaldoActual(data.saldo_actual);
      }
    } catch (error) {
      console.error('Error al cargar saldo:', error);
    }
  };

  const handleActualizarSaldo = async () => {
    setLoadingSaldo(true);
    try {
      const response = await fetch(`${SALDO_DEV_URL}/get_consultasaldo.php`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      if (data.success) {
        setSaldoActual(data.saldo_actual);
      }
    } catch (err) {
      console.error('Error actualizando saldo:', err);
    } finally {
      setLoadingSaldo(false);
    }
  };

  const handleAgregarSaldo = () => {
    navigate('/agregar_saldo');
  };

const handleActivarPublicacion = async () => {
    setMensajeActivar('');
    setErrorActivar('');

    if (!planSeleccionado) {
      setErrorActivar('Debes seleccionar un plan.');
      return;
    }
    if (!publicacionSeleccionada) {
      setErrorActivar('Debes seleccionar una publicación.');
      return;
    }

    setLoadingActivar(true);
    try {
      const formData = new FormData();
      formData.append('codigo_plan', planSeleccionado);
      formData.append('id_publicacion', publicacionSeleccionada);

      const response = await fetch(`${SALDO_DEV_URL}/activar_plan.php`, {
        method: 'POST',
        credentials: 'include',
        body: formData
      });

      let result;
      try { result = await response.json(); } catch { result = {}; }

if (response.ok && result.success) {
        setMensajeActivar('TU PUBLICACIÓN FUE EXITOSA, SERÁ PUBLICADA EN BREVE...');
        setSaldoActual(result.saldo_nuevo || 0);
        setPlanSeleccionado('');
        setPublicacionSeleccionada('');
        setDiasAdquiridos('');
        setTimeout(() => {
          navigate('/gestion_avisos');
        }, 2500);
      } else {
        setErrorActivar(result.message || 'Error al activar la publicación.');
      }
    } catch (err) {
      setErrorActivar('Error de conexión. Intenta nuevamente.');
    } finally {
      setLoadingActivar(false);
    }
  };

  return (
    <>
      <div className="saldo-oc-container">
      
      {/* ==================== SECCIÓN 1: AÑADIR SALDO ==================== */}
      <div className="saldo-oc-content">
        <h1 className="saldo-oc-titulo">AÑADIR SALDO :</h1>
        <hr className="saldo-oc-linea" />

        <div className="saldo-oc-saldo-row">
          <p className="saldo-oc-subtitulo">Saldo Actual : ${saldoActual.toLocaleString('es-CL')}</p>
          <button className="btn-actualizar-saldo" onClick={handleActualizarSaldo} disabled={loadingSaldo}>
            {loadingSaldo ? 'ACTUALIZANDO...' : 'ACTUALIZAR'}
          </button>
        </div>

        <div className="saldo-oc-texto-info">
          <p className="saldo-oc-texto">
            Una vez agregado tu saldo, no puedes retirarlo, es por ello que debes verificar bien los planes o el plan que necesitas.
          </p>
          <p className="saldo-oc-texto">
            Este es tu saldo virtual a favor que tienes actualmente, con ello puedes activar tus publicaciones, ya sea por 7 días, 30 o 90 días de corridos, dependiendo del plan que escojas, si es para los destacados o premium, en la siguiente sección se detallará el costo por plan para que verifiques, cuanto saldo quieres añadir.
          </p>
        </div>

        <button className="btn-agregar-saldo" onClick={handleAgregarSaldo}>
          AGREGAR SALDO
        </button>
      </div>

      {/* ==================== SECCIÓN 2: ORDEN DE COMPRA ==================== */}
      <div className="saldo-oc-content">
        <h1 className="saldo-oc-titulo">ORDEN DE COMPRA :</h1>
        <hr className="saldo-oc-linea" />

        <div className="saldo-oc-texto-info">
          <p className="saldo-oc-texto">
            Existen distintos planes asociados para activar tu publicación en un periodo de tiempo que tu elijas : se medirá en días y horas, ya que tendrás la opción de pausar tus publicaciones y volverlas a activar, el periodo son días de corridos, en caso que pauses tu publicación, tu periodo de termino será distinto a los ejemplos que se indicarán :
          </p>
          <p className="saldo-oc-texto">
            A continuación se explicarán los detalles de los planes con sus costos, con ello podrás determinar el saldo que quieras añadir.
          </p>
        </div>

{/* ---------- NOTA PRECIOS ---------- */}
<p className="nota-periodo-rojo">
  * Los precios de los planes están sujetos a cambios con previo aviso, dependiendo de la demanda del servicio. Para más información revisa nuestros{' '}
  <a href="/textos-legales#terminos" style={{color: '#FF0000'}}>Términos y Condiciones</a>.
</p>

{/* ---------- PLANES PREMIUM ---------- */}
<h4 className="categoria-titulo categoria-premium">PLANES PREMIUM</h4>
        <div className="planes-grid">
          {planes.premium.map(plan => (
            <div
              key={plan.id}
              className={`plan-card ${planSeleccionado === plan.id ? 'plan-selected' : ''}`}
              onClick={() => {
                setPlanSeleccionado(plan.id);
                setDiasAdquiridos(`${plan.dias} días`);
              }}
            >
              <div className="plan-header">
                <div>
                  <div className="plan-nombre">{plan.nombre}</div>
                  <div className="plan-precio">${plan.precio.toLocaleString('es-CL')}</div>
                </div>
                <div className={`radio-circle ${planSeleccionado === plan.id ? 'radio-selected' : ''}`}></div>
              </div>
              <ul className="plan-features">
                {(featuresMap[plan.id] || []).map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ---------- PLANES DESTACADOS ---------- */}
        <h4 className="categoria-titulo categoria-destacados">PLANES DESTACADOS</h4>
        <div className="planes-grid">
          {planes.destacado.map(plan => (
            <div
              key={plan.id}
              className={`plan-card ${planSeleccionado === plan.id ? 'plan-selected' : ''}`}
              onClick={() => {
                setPlanSeleccionado(plan.id);
                setDiasAdquiridos(`${plan.dias} días`);
              }}
            >
              <div className="plan-header">
                <div>
                  <div className="plan-nombre">{plan.nombre}</div>
                  <div className="plan-precio">${plan.precio.toLocaleString('es-CL')}</div>
                </div>
                <div className={`radio-circle ${planSeleccionado === plan.id ? 'radio-selected' : ''}`}></div>
              </div>
              <ul className="plan-features">
                {(featuresMap[plan.id] || []).map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ---------- FORMULARIO DE SELECCIÓN ---------- */}
        <div className="formulario-orden">
          <div className="campo-formulario">
            <label className="campo-label">Plan seleccionado :</label>
            <input
              type="text"
              className="campo-input"
              value={planSeleccionado ? `${planSeleccionado}` : ''}
              readOnly
              placeholder="Selecciona un plan arriba"
            />
          </div>

          <div className="campo-formulario">
            <label className="campo-label">Publicaciones :</label>
            <select 
              className="campo-select"
              value={publicacionSeleccionada}
              onChange={(e) => setPublicacionSeleccionada(e.target.value)}
            >
              <option value="">-- Selecciona una publicación --</option>
              {publicacionesOrdenadas.map(pub => {
                const estado = obtenerEstadoPublicacion(pub.estado_plan);
                return (
                  <option key={pub.id} value={pub.id} style={{ color: ESTADO_COLOR[estado] }}>
                    {pub.nombre} - {ESTADO_LABEL[estado]}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="campo-formulario">
            <label className="campo-label">Días adquiridos :</label>
            <input 
              type="text" 
              className="campo-input"
              value={diasAdquiridos}
              readOnly
              placeholder=""
            />
          </div>
        </div>

<div className="boton-activar-container">
          {errorActivar && (
            <p className="mensaje-error-activar">{errorActivar}</p>
          )}
          {mensajeActivar && (
            <p className="mensaje-exito-activar">{mensajeActivar}</p>
          )}
          <button
            className="btn-activar-publicacion"
            onClick={handleActivarPublicacion}
            disabled={loadingActivar}
          >
            {loadingActivar ? 'PROCESANDO...' : 'ACTIVAR PUBLICACION'}
          </button>
          <p className="saldo-oc-texto" style={{marginTop: '20px', textAlign: 'center'}}>
            💬 ¿Tienes dudas sobre los planes o el proceso de activación? Contáctanos por WhatsApp y te ayudamos:{' '}
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" style={{color: '#008000', fontWeight: 'bold'}}>
              +56 9 2967 4732
            </a>
          </p>
        </div>
      </div>
</div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </>
  );
};

export default SaldoOrdenCompra;
